export type Hash = `0x${string}`
export type Token = {
  name: string
  symbol: string
  address: Hash
  decimals: number
}

// which use for airdrop
export type AirdropItem = {
  addr: Hash
  amount: bigint
}

export type AirdropList = AirdropItem[]

export enum ErrorType {
  AMOUNT = 'AMOUNT',
  ADDRESS = 'ADDRESS',
  DUPLICATE = 'DUPLICATE',
  BAD_ADDRESS = 'BAD_ADDRESS',
}

export type ErrorItem = {
  line: number
  type: ErrorType
  lineLength: number
  errorMessage: string
}

export type ErrorsList = ErrorItem[]

export type OwnedToken = Token & { balance: string }

export type TokenListItem = OwnedToken & {
  label: string
}

export type TokenList = TokenListItem[]

export enum Strategies {
  SELF_GENERATED = 'SELF_GENERATED',
  EXTERNAL_WALLET = 'EXTERNAL_WALLET',
}

export type GasParamsKeys = 'maxFeePerGas' | 'maxPriorityFeePerGas' | 'gasPrice'
export type GasParams =
  | { gasPrice: bigint; maxFeePerGas?: undefined; maxPriorityFeePerGas?: undefined }
  | { maxFeePerGas: bigint; maxPriorityFeePerGas: bigint; gasPrice?: undefined }
export type GasParamsApiResponse = Record<GasParamsKeys, undefined | string>

export type GasParamsStringType =
  | { gasPrice: string; maxFeePerGas?: undefined; maxPriorityFeePerGas?: undefined }
  | { maxFeePerGas: string; maxPriorityFeePerGas: string; gasPrice?: undefined }

export type FetchFeeDataApiResult = GasParamsApiResponse & {
  formatted: {
    gasPrice: string | null
    maxFeePerGas: string | null
    maxPriorityFeePerGas: string | null
  }
}
export type FetchFeeDataResult = GasParams & {
  formatted: {
    gasPrice: string | null
    maxFeePerGas: string | null
    maxPriorityFeePerGas: string | null
  }
}

export enum Network {
  ETH_MAINNET = 'eth-mainnet',
  /** @deprecated - Will be removed in subsequent versions */
  ETH_GOERLI = 'eth-goerli',
  /** @deprecated - Will be removed in subsequent versions */
  /** @deprecated - Will be removed in subsequent versions */
  ETH_SEPOLIA = 'eth-sepolia',
  OPT_MAINNET = 'opt-mainnet',
  /** @deprecated - Will be removed in subsequent versions */
  OPT_KOVAN = 'opt-kovan',
  OPT_GOERLI = 'opt-goerli',
  ARB_MAINNET = 'arb-mainnet',
  /** @deprecated - Will be removed in subsequent versions */
  ARB_RINKEBY = 'arb-rinkeby',
  ARB_GOERLI = 'arb-goerli',
  MATIC_MAINNET = 'polygon-mainnet',
  MATIC_MUMBAI = 'polygon-mumbai',
  ASTAR_MAINNET = 'astar-mainnet',
}

export type Params = {
  to: Hash
  from: Hash
  data: Hash
  gas?: bigint
  value: bigint
  nonce?: number
  gasPrice?: bigint
  maxFeePerGas?: bigint
  maxPriorityFeePerGas?: bigint
}
